// Single source of truth — content sourced strictly from the provided resume
// and https://www.manojsuthar.com/. Do not add information beyond these.

export const profile = {
    name: "Manoj Suthar",
    title: "Senior Software Engineer",
    handle: "manojsuthar",
    location: "India",
    summary:
        "Results-driven Software Engineer with 5+ years of hands-on experience architecting and delivering high-throughput, cloud-native microservices at scale. Proven track record at Nagarro and Capiter in building distributed systems using Java, Spring Boot, and Apache Kafka that handle mission-critical workloads. Passionate about clean code, platform engineering, and leveraging Generative AI to build next-generation products. Holds active certifications in Generative AI.",
    aboutShort:
        "Software engineer specializing in Java, Spring Boot, and backend engineering with a deep understanding of distributed systems, cloud-native architectures, and microservices. Focused on building solutions that are both scalable and resilient — meeting current demands and adaptable to future growth.",
    email: "hapticsapps@gmail.com",
    phone: "+91-9636579852",
    resumeUrl: "/resume.pdf",
    socials: {
        linkedin: "https://linkedin.com/in/manoj-suthar",
        github: "https://github.com/manojsuthar123",
        twitter: "https://x.com/manoj__official",
        medium: "https://manoj-suthar.medium.com/",
        instagram: "https://www.instagram.com/manojsuthar07",
        website: "https://www.manojsuthar.com/",
    },
};

export const skills = [
    {
        group: "Languages",
        items: ["Java", "JavaScript", "Python", "Kotlin"],
    },
    {
        group: "Frameworks",
        items: [
            "Spring Boot",
            "Langchain4j",
            "Angular",
            "Node.js",
            "Flutter",
            "Kafka",
        ],
    },
    {
        group: "DevOps & Cloud",
        items: ["Docker", "Kubernetes", "Jenkins", "AWS", "GCP", "CI/CD"],
    },
    {
        group: "Observability",
        items: ["Prometheus", "Grafana", "ELK Stack", "Zipkin", "JMeter", "VisualVM"],
    },
    {
        group: "AI / Data",
        items: [
            "GenAI (Oracle Certified)",
            "MCP",
            "Vector Databases",
            "LLM Integration",
        ],
    },
    {
        group: "Practices",
        items: ["Microservices", "12-Factor Apps", "TDD", "Design Patterns", "DDD"],
    },
];

export const experience = [
    {
        role: "Senior Software Engineer",
        company: "Nagarro",
        period: "Sep 2022 — Present",
        duration: "3+ yrs",
        bullets: [
            "Designed and deployed 20+ production microservices with distributed system capabilities, achieving 99.9% uptime SLAs and supporting 500K+ daily transactions.",
            "Built high-performance batch processing pipelines using Spring Batch, reducing ETL processing time by 40%; instrumented end-to-end with Prometheus and Grafana dashboards.",
            "Containerized and orchestrated Spring Boot services on Kubernetes (multi-node clusters), cutting deployment lead time by 60% via automated CI/CD pipelines in Jenkins.",
            "Championed 12-Factor App methodology and SOLID design patterns across 3 cross-functional teams, improving code maintainability scores by 30% in SonarQube reviews.",
            "Implemented comprehensive unit and integration test suites (JUnit 5 + Mockito) with >85% code coverage, reducing post-release defects by 50%.",
            "Actively integrated Generative AI capabilities (LLM APIs, Vector Databases, MCP) into internal tooling, accelerating developer productivity.",
        ],
    },
    {
        role: "Backend Engineer",
        company: "Capiter LLC",
        period: "Apr 2022 — Sep 2022",
        duration: "6 mos",
        context: "B2B e-commerce platform (YC-backed, MENA region)",
        bullets: [
            "Architected a SNPL (Sell Now Pay Later) microservice processing $2M+ monthly checkout volume, integrating multi-step payment orchestration with Kafka event streaming.",
            "Designed distributed tracing with Zipkin and a centralized ELK log analysis stack, reducing mean time to resolution (MTTR) for production incidents by 45%.",
            "Implemented bulk data processing with Spring Batch for large B2B order ingestion, enabling ingestion of 100K+ SKUs per batch run with error recovery and retry logic.",
        ],
    },
    {
        role: "Android Developer",
        company: "Open Innovations Lab",
        period: "Jun 2021 — Apr 2022",
        duration: "10 mos",
        context: "Product startup focused on mobile-first solutions",
        bullets: [
            "Shipped 3 production mobile applications using Java, Kotlin (native Android), and Flutter (cross-platform iOS/Android), collectively reaching 10K+ downloads.",
            "Integrated Firebase (Auth, Firestore, Push Notifications, Analytics) and AWS EC2 backend services, reducing backend setup time by 70% vs. custom server approach.",
            "Built real-time features using Socket.io and MongoDB, enabling live chat and order-tracking capabilities with sub-200ms latency.",
        ],
    },
];

export const projects = [
    {
        name: "FilesCAD",
        url: "http://filescad.com/",
        description: "Featured project from manojsuthar.com",
    },
    {
        name: "Xelere8",
        url: "https://play.google.com/store/apps/details?id=com.xelere8.bike",
        description: "Featured project from manojsuthar.com",
    },
    {
        name: "TailorHut",
        url: "https://play.google.com/store/apps/details?id=app.tailorhut.in",
        description: "Featured project from manojsuthar.com",
    },
];

export const certifications = [
    {
        name: "Oracle Certified Generative AI Professional",
        issuer: "Oracle University",
    },
    {
        name: "AI Agents in Java with Generative AI",
        issuer: "Coursera",
    },
    {
        name: "DevSecOps Technical Basics",
        issuer: "Mercedes-Benz Global Cyber Security",
    },
    {
        name: "Certified Vaadin 24 Developer",
        issuer: "Vaadin",
    },
];

export const education = {
    degree: "B.Tech, Computer Science & Engineering",
    school: "Jodhpur Institute of Engineering and Technology",
    location: "Jodhpur, Rajasthan",
    period: "2017 — 2021",
};

export const navLinks = [
    { label: "about", href: "#about" },
    { label: "skills", href: "#skills" },
    { label: "experience", href: "#experience" },
    { label: "projects", href: "#projects" },
    { label: "contact", href: "#contact" },
];
